// 递归数据
export default (id = 'id', parentId = 'parentId', children = 'children') =>
  function recurse(treeDatas = [], $parent) {
    const trees = [];
    const parent = $parent || {};
  /* eslint-disable */
  for (let i = 0, length = treeDatas.length; i < length; i++) {
    const treeData = treeDatas[i];
    if ((!treeData[parentId] && !parent[id]) || (parent[id] && treeData[parentId] === parent[id])) {
      treeData[children] = recurse(treeDatas, treeData);
      treeData.hasChildren = treeData[children].length > 0;
      if(!treeData.hasChildren){
        delete treeData[children];
      }
      trees.push(treeData);
    }
    //  else if ((treeData[parentId] && treeData[id]) && !treeDatas.filter(item => item[id] === treeData[parentId]).length) {
    //   treeData.leaf=  !treeData[children] || !treeData[children].length;
    //   trees.push(treeData);
    // }
  }
  /* eslint-enable */
    return trees;
  };
